import { render, staticRenderFns } from "./PageManufacturerList.vue?vue&type=template&id=325f7280"
import script from "./PageManufacturerList.vue?vue&type=script&lang=js"
export * from "./PageManufacturerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports